import { render } from "./GoalScoringDistribution.vue?vue&type=template&id=0f03b7d9&scoped=true"
import script from "./GoalScoringDistribution.vue?vue&type=script&lang=js"
export * from "./GoalScoringDistribution.vue?vue&type=script&lang=js"

import "./GoalScoringDistribution.vue?vue&type=style&index=0&id=0f03b7d9&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f03b7d9"]])

export default __exports__